import { useEffect, useState } from "react";

const KEY = "hubert_cookie_consent";

export default function CookieBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] bg-black/95 border-t-2 border-t-[#4a0404] backdrop-blur-md" data-testid="cookie-bar">
      <div className="max-w-5xl mx-auto px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <p className="text-xs sm:text-sm text-neutral-400 leading-relaxed">
          Používáme cookies pro provoz webu a analýzu návštěvnosti. Analytické cookies aktivujeme jen s vaším souhlasem. <a href="/ochrana-osobnich-udaju" className="text-nv hover:underline" data-testid="cookie-gdpr-link">Více o zpracování údajů</a>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => decide("rejected")} data-testid="cookie-reject"
            className="vhs-btn text-xs tracking-widest px-4 py-2 border border-white/15 text-neutral-400 hover:text-white">
            ODMÍTNOUT
          </button>
          <button onClick={() => decide("accepted")} data-testid="cookie-accept"
            className="hud-btn vhs-btn text-xs tracking-widest px-4 py-2 font-head">
            [ PŘIJMOUT ]
          </button>
        </div>
      </div>
    </div>
  );
}
